const originalConsole = { ...console };

export const GlobalDebug = (() => {
  let isDebugSuppressed = false;
  
  return (debugOn: boolean, suppressAll: boolean = false): void => {
    if (debugOn === false && !isDebugSuppressed) {
      isDebugSuppressed = true;
      
      // Always suppress console.log
      console.log = () => {};
      
      if (suppressAll) {
        console.info = () => {};
        console.warn = () => {};
        console.error = () => {};
        console.debug = () => {};
        console.trace = () => {};
        console.table = () => {};
        console.group = () => {};
        console.groupCollapsed = () => {};
        console.groupEnd = () => {};
      } else {
        // Preserve important console methods
        console.info = originalConsole.info.bind(originalConsole);
        console.warn = originalConsole.warn.bind(originalConsole);
        console.error = originalConsole.error.bind(originalConsole);
      }
    } else if (debugOn === true && isDebugSuppressed) {
      isDebugSuppressed = false;
      // Restore all original console methods
      Object.assign(console, originalConsole);
    }
  };
})();

// Initialize suppression immediately based on environment
if (process.env.NODE_ENV === "production" || process.env.REACT_APP_ENV === "STAGING") {
  GlobalDebug(false);
}